import { render, staticRenderFns } from "./InventoryRequestEdit.vue?vue&type=template&id=b499ff2e&scoped=true&"
import script from "./InventoryRequestEdit.vue?vue&type=script&lang=js&"
export * from "./InventoryRequestEdit.vue?vue&type=script&lang=js&"
import style0 from "./InventoryRequestEdit.vue?vue&type=style&index=0&id=b499ff2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b499ff2e",
  null
  
)

export default component.exports